import React from 'react';
import ReactDOM from 'react-dom';
import MobileDetect from 'mobile-detect';

import EmojiIsLife from './components/EmojiIsLife.jsx';
import systemHelper from './helpers/system';
import data from './data/data';


/**
 * Calls a function when the DOM is ready
 * @param {Function} callback - The function to call
 * @returns {undefined} undefined
 */
function domReady(callback) {
  const doc = document;
  const attach = 'addEventListener';

  if (doc[attach]) {
    doc[attach]('DOMContentLoaded', callback);
  } else {
    window.attachEvent('onload', callback);
  }
}


/**
 * Loads the app
 * @param {Function} callback - The function to call
 * @returns {undefined} undefined
 */
domReady(() => {
  const md = new MobileDetect(window.navigator.userAgent);
  const htmlEl = document.getElementsByTagName('html')[0];
  const touch = md.mobile() ? true : false;
  const cssTransforms3d =
    htmlEl.className.indexOf('no-csstransforms3d') === -1;
  const appContainer = document.getElementsByClassName('app-container')[0];
  const iOSVersion = systemHelper.iOSVersion();
  const androidVersion = systemHelper.androidVersion();
  const isFirefox = systemHelper.isFirefox();
  const isIEOrEdge = systemHelper.isIEOrEdge();

  if (iOSVersion === 8 || iOSVersion === 9) {
    const originalClass = htmlEl.className;
    const newClass = originalClass + ' iOS-' + iOSVersion.toString();

    htmlEl.className = newClass;
  }

  if (androidVersion) {
    const originalClass = htmlEl.className;
    const newClass = originalClass + ' android android-v-' + androidVersion.toString();

    htmlEl.className = newClass;
  }

  if (isFirefox) {
    const originalClass = htmlEl.className;
    const newClass = originalClass + ' firefox';

    htmlEl.className = newClass;
  }

  if (isIEOrEdge) {
    const originalClass = htmlEl.className;
    const newClass = originalClass + ' ie-edge';

    htmlEl.className = newClass;
  }

  ReactDOM.render(
    <EmojiIsLife
      minDesktopWidth={768}
      cssTransforms3d={cssTransforms3d}
      touch={touch}
      data={data}
    />, appContainer);
});



/** WEBPACK FOOTER **
 ** ./assets/js/src/main.js
 **/